/** Prevent event propagation */
export function eventStopPropagation(ev) {
  ev.preventDefault();
  ev.stopPropagation();
}